/**
 * @generated SignedSource<<e81ad888de1a2e62d517e73b3e05f6fb>>
 * @relayHash 2e3bd1d6512b9ae71065f09a73168564
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 552419f8111cbc0e39f477f767ccc3d794398bc28df473f15c00b29d6589071e

import type { ConcreteRequest } from 'relay-runtime';
export type TeamCustomFieldCardinality = "MULTI" | "SINGLE" | "%future added value";
export type TeamCustomFieldType = "NUMBER" | "SELECTOR" | "STRING" | "TEAM" | "USER" | "%future added value";
export type TeamCreateCustomFieldPayload = {
  cardinality: TeamCustomFieldCardinality;
  description?: string | null;
  name: string;
  options?: ReadonlyArray<string> | null;
  scope?: TeamCustomFieldScopeInput | null;
  type: TeamCustomFieldType;
};
export type TeamCustomFieldScopeInput = {
  teamTypeId?: string | null;
  userbase?: boolean | null;
};
export type CreateCustomFieldMutation$variables = {
  customFieldData: TeamCreateCustomFieldPayload;
  scopeId: string;
};
export type CreateCustomFieldMutation$data = {
  readonly team: {
    readonly createCustomField: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string;
      readonly type: TeamCustomFieldType;
    } | null;
  } | null;
};
export type CreateCustomFieldMutation = {
  response: CreateCustomFieldMutation$data;
  variables: CreateCustomFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customFieldData"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeId"
  }
],
v1 = [
  {
    "concreteType": "TeamMutation",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "customFieldData",
            "variableName": "customFieldData"
          },
          {
            "kind": "Variable",
            "name": "scopeId",
            "variableName": "scopeId"
          }
        ],
        "concreteType": "TeamDetailedCustomFieldInfo",
        "kind": "LinkedField",
        "name": "createCustomField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CreateCustomFieldMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCustomFieldMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "552419f8111cbc0e39f477f767ccc3d794398bc28df473f15c00b29d6589071e",
    "metadata": {},
    "name": "CreateCustomFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1f4afdabb73a1c366753d7d0ca680072";

export default node;
